import {
  Box,
  Button,
  CardContent,
  CardHeader,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { AppRootState } from '../../../app/store';
import { checkAutoLogin } from '../../Login/auth-reducer';
import {setCurrentLocation } from '../../../app/cookies';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AddIcon from '@mui/icons-material/Add';
import { setIsNewAccount, UserType } from '../../Users/users-reducer';
import { cleanNewAccount, createNewAccountTC, NewAccountType, setNewAccountDescription, setNewAccountEmail, setNewAccountName, setNewAccountStatus } from './newAccount-reducer';
import { NewAccountUsersList } from './NewAccountUsersList';
import { AlertNotSavedChanges } from '../../common/AlertNotSavedChanges';
import { useCallbackPromt } from '../../common/useCallbackPromt';

export const NewAccountData = () => {
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const newAccountState = useSelector<AppRootState, NewAccountType>(state => state.newAccount)
  const account = newAccountState.account
  console.log('ACCOUNT FROM STATE: ', account)
  const users = useSelector<AppRootState, Array<UserType>>(state => state.newAccount.account.users)
  const isNotSavedChanges = useSelector<AppRootState, boolean>(state => state.newAccount.isNotSavedChanges)

  
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [showPromt, confirmNavigation, cancelNavigation] = useCallbackPromt(showAlert, account, () => { dispatch(cleanNewAccount())})
  
  const navigate = useNavigate()
  const [values, setValues] = useState({ ...account })
  const [checkbox, setCheckbox] = useState(account.isActive)
  let stateLabel
  checkbox ? stateLabel = 'Active' : stateLabel = ''
  const [label, setLabel] = useState(stateLabel)
  const dispatch = useDispatch()

  useEffect(() => {
    let token = checkAutoLogin(dispatch, true)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } else {
      if (token !== null && isLoggedIn === false) {
        return navigate(`/accountsList`)
      }
    }
    setCurrentLocation(`\\ Accounts \\ New Account `)
    isNotSavedChanges && setShowAlert(true)
  }, [isLoggedIn])

  console.log('Values', values)
  let isSaveAccButtonDisabled: boolean
  values.name === "" || values.email === "" ? isSaveAccButtonDisabled = true : isSaveAccButtonDisabled = false

  let reqBody = {
    ...values,
    isActive: checkbox,
  }

  // const createNewAccount = () => {
  //   setShowAlert(false)
  //   console.log('request BODY', reqBody)
  //   dispatch(createNewAccountTC({account: reqBody}))
  //   navigate(`/accountsList/`)
  // }

  async function createNewAccount() {
    setShowAlert(false)
    await dispatch(createNewAccountTC({account: reqBody}))
    navigate(`/accountsList/`)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  event.target.name === "name" ? dispatch(setNewAccountName(event.target.value)) :
  event.target.name === "email" ? dispatch(setNewAccountEmail(event.target.value)) : dispatch(setNewAccountDescription (event.target.value))
  setShowAlert(true)
  };

  const handleChangeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
    setCheckbox(event.target.checked)
    event.target.checked ? setLabel('Active') : setLabel('')
    dispatch(setNewAccountStatus(event.target.checked))
  }

  const addNewUser = () => {
    setShowAlert(false)
    setCurrentLocation(`\\ Accounts \\ New Account \\ New User`)
    dispatch(setIsNewAccount(true))
    navigate(`/usersList/newUser`, {state:{account}})
  }

  return (
    <>
      <Container >
        <AlertNotSavedChanges 
          showAlert = {showPromt}
          confirmNavigation = {confirmNavigation}
          cancelNavigation = {cancelNavigation}
        />
        <Grid container style={{ paddingTop: '70px', paddingBottom: '50px' }} spacing={3} alignItems="center">
          <Grid item xl={8} md={8} xs={6} style={{ paddingTop: '30px' }}>
              <Button onClick={(e) => navigate(`/accountsList/`)} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
              Back to Accounts list
          </Button>
          </Grid>
          <Grid item xl={4} md={4} xs={6} >
            <Button style={{ float: 'right' }}
              color="info"
              variant="contained"
              disabled={isSaveAccButtonDisabled}
              onClick={createNewAccount}
            >
              Save
            </Button>
          </Grid>
          </Grid>
        <Box sx={{ pt: 3 }}>
          {/* <Box sx={{ minWidth: 1050 }}> */}
          <Box >
            <form
              autoComplete="off"
              noValidate
            >
              <CardHeader
                title={`Create new account: `}
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="name"
                      autoFocus
                      required
                      variant="outlined"
                      onChange={handleChange}
                      value={values.name}
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      onChange={handleChange}
                      //disabled={isAdmin}
                      required
                      value={values.email}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      onChange={handleChange}
                      value={values.description}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid alignSelf={'center'}
                    item
                    xl={11}
                    xs={11}><Typography style={{ float: 'right', verticalAlign: 'bottom' }}> Status: </Typography>
                  </Grid>
                  <Grid
                    item
                    xl={1}
                    xs={1}>
                    <div >
                      <FormControlLabel control={<Switch color='info' name="isActive" checked={checkbox} onChange={handleChangeCheckbox} />} label={label} />
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
              <Grid item >
                {users.length === 0 ? 
                <Grid container style={{ textAlign: 'center', marginTop: '70px' }} >
                  <Grid item xs={12}>
                    <PersonOutlineIcon style={{ fontSize: '70px', color: 'rgba(0,0,0, 0.55)' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant='caption' >
                      No users have been added
                    </Typography>
                  </Grid>
                  <Grid container style={{ display: 'flex', margin: '10px', padding: '3px', paddingTop: '4px', fontSize: '14px', justifyContent: 'center', color: 'white' }}>
                    <span style={{ color: 'white', cursor: 'pointer', backgroundColor: '#00a0d1', padding: '3px', paddingRight: '8px' }}
                     onClick={addNewUser}>
                      <AddIcon style={{ color: 'white', verticalAlign: 'text-bottom' }} fontSize='small' id='icon' />
                      Add new  user</span>
                  </Grid>
                </Grid>
                : <NewAccountUsersList addNewUser={addNewUser} account={account} />}
              </Grid>
            </form>
          </Box>
        </Box>
      </Container>
    </>
  );
}
